import { render, staticRenderFns } from "./modal-news.vue?vue&type=template&id=0134e70f"
import script from "./modal-news.vue?vue&type=script&lang=js"
export * from "./modal-news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports